import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import { mergeParams } from "../../../helpers/helpers";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const [comboEscolas, setComboEscolas] = useState([]);
  const [lista, setLista] = useState([]);
  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      { nome: "", CPF: "", exibirInativos: false, email: "", escola: "" },
      location
    )
  );
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarComboEscolas();

    if (
      dadosFiltros.nome ||
      dadosFiltros.CPF ||
      dadosFiltros.email ||
      dadosFiltros.escola
    ) {
      carregar();
    }
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregar = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);
    setCarregando(true);

    api
      .get("profissionais/listar", filtrosEnviar)
      .then((res) => {
        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar profissionais");
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dadosFiltros.nome,
      },
      CPF: {
        label: "CPF",
        type: "number",
        space: 4,
        value: dadosFiltros.CPF,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 2,
        value: dadosFiltros.exibirInativos,
      },
      email: {
        label: "Email",
        type: "text",
        space: 6,
        value: dadosFiltros.email,
      },
      escola: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: dadosFiltros.escola,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirProf = (registro) => {
    history.push(`/app/professional/${registro.id}`);
  };

  const tRegistros = {
    title: "Profissionais",
    onLineClick: abrirProf,
    newItemAction: () => history.push("/app/professional/cadastro"),
    columns: [
      {
        name: "usuarioNome",
        label: "Nome",
      },
      {
        name: "usuarioCPF",
        label: "CPF",
      },
      {
        name: "usuarioEmail",
        label: "Email",
      },
      {
        name: "escolaNomeFantasia",
        label: "Escola",
      },
      {
        name: "acessoLiberado",
        label: "Ativo",
        checkbox: true,
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
